'use client';
import { createContext, useContext, useState, useEffect } from 'react'
import { usePathname } from 'next/navigation'
import ChartModal from '../ui/ChartModal'

interface ChartModalContextType {
    isOpen: boolean
    openChartModal: () => void
    closeChartModal: () => void
}

const ChartModalContext = createContext<ChartModalContextType | null>(null)

export const ChartModalProvider = ({ children }: { children: React.ReactNode }) => {
    const [isOpen, setIsOpen] = useState(false)
    const pathname = usePathname()

    const openChartModal = () => setIsOpen(true)
    const closeChartModal = () => setIsOpen(false)

    // 라우터 변경 시 모달 닫기
    useEffect(() => {
        if (isOpen) {
            closeChartModal()
        }
    }, [pathname])

    return (
        <ChartModalContext.Provider value={{ isOpen, openChartModal, closeChartModal }}>
            {children}
            {isOpen && <ChartModal onClose={closeChartModal} />}
        </ChartModalContext.Provider>
    )
}

export const useChartModal = () => {
    const context = useContext(ChartModalContext)
    if (!context) {
        return {
            isOpen: false,
            openChartModal: () => { },
            closeChartModal: () => { },
        }
    }
    return context
} 